export type { RouteLinkProps } from './RouteLink'
export { RouteLink } from './RouteLink'
